<template>
  <v-container class="px-0">
  </v-container>
</template>

<script>
  export default {
    name: 'ExportImport',

    data () {
      return {
        breadcrumbsItems: [ 
          { href: '/home', disabled: false, text: this.$t("home").toUpperCase(), to: '/home'},
          { href: '/export_import', disabled: true, text: this.$t("export_import").toUpperCase()}
        ]  
      }  
    },    
    created: function() {
      this.$store.dispatch('_updateBreadcrumbs', this.breadcrumbsItems);
    },
    methods: {}

  }
</script>
